import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconAkademieMono = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    aria-label="IconAkademieMono"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="m6.334 6.115 5.493-2.318a.285.285 0 0 0 0-.524L6.334.954a.28.28 0 0 0-.22 0L.173 3.462A.28.28 0 0 0 0 3.723v3.623a.41.41 0 0 0 .82 0V3.88l5.293 2.234c.071.03.151.03.22 0" />
    <path d="M7.81 6.101c.059.204.1.422.1.667 0 .973-.671 1.813-1.711 1.813-.924 0-1.662-.655-1.662-1.813 0-.247.05-.461.112-.663L1.825 4.913a4.9 4.9 0 0 0-.357 1.855c0 2.416 1.358 4.145 3.792 4.296.923.05 2.03-.235 2.734-1.04l.134.89h2.853V4.761z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconAkademieMono);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
